import AnalyticsPoint from 'gatsby-plugin-purina-analytics/AnalyticsPoint';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import ArticleOverlayCard from 'src/components/article_card/ArticleOverlayCard';
import { getArticleCardProps } from '../utils/getArticleCardProps';

interface ArticleRelatedProps {
  related: {
    node: IArticleCard;
  }[];
}

const ArticleRelated: React.FC<ArticleRelatedProps> = ({ related }) => {
  const { t } = useTranslation();

  if (related.length !== 3) {
    return null;
  }

  return (
    <AnalyticsPoint
      type="module"
      typeLabel="article_related_articles"
      label="related articles"
      className="pds-flex pds-items-center pds-justify-center pds-bg-surface-layer"
    >
      <div className="pds-flex pds-w-full pds-max-w-[1360px] pds-flex-col pds-gap-5 pds-px-4 pds-py-6 sm:pds-p-6 [&_img]:pds-max-w-full">
        <h2 className="pds-m-0 pds-text-title-lg">{t('Related articles')}</h2>
        <div className="pds-grid pds-grid-cols-1 pds-gap-4.5 lg:pds-grid-flow-col lg:pds-grid-cols-[50%,50%] lg:pds-gap-0 lg:&first:pds-col-[1] lg:&first:*:pds-h-full">
          <div
            data-id={related[0].node.drupal_id}
            key={`0-${related[0].node.drupal_internal__nid}`}
          >
            <ArticleOverlayCard {...getArticleCardProps(related[0].node)} condensed={false} />
          </div>
          <div className="pds-flex pds-w-full pds-flex-col pds-gap-4.5 sm:pds-flex-row lg:pds-flex-col lg:pds-pl-4.5">
            {related.slice(1, 3).map(({ node: article }, index: number) => {
              return (
                <div
                  data-id={article.drupal_id}
                  className="pds-max-h-min"
                  key={`${index}-${article.drupal_internal__nid}`}
                >
                  <ArticleOverlayCard {...getArticleCardProps(article)} condensed />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </AnalyticsPoint>
  );
};

export default ArticleRelated;
